import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { checkToken, resetPassword } from "../actions/user/user";
import Alert from "../components/global/Alert";

const ResetPassword = ({
    checkToken,
    resetPassword,
    match,
    user: { isAuthenticated }
}) => {
    const [formData, setFormData] = useState({
        password: "",
        repassword: ""
    });

    const { password, repassword } = formData;

    useEffect(() => {
        checkToken(match.params.token);
    }, [checkToken, match.params.token]);

    const onChange = e =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = e => {
        e.preventDefault();

        resetPassword(match.params.token, { password, repassword });

        setFormData({ password: "", repassword: "" });
    };

    const renderForm = () => {
        if (isAuthenticated) {
            return (
                <div id="admin-login" className="mx-auto mt-5">
                    <div className="card">
                        <div className="card-header">
                            <h1 className="text-center h2 p-1">
                                Reset Password
                            </h1>
                        </div>
                        <div className="card-body">
                            <p className="card-title text-center mb-4">
                                Enter your new password below
                            </p>
                            <form className="form" onSubmit={e => onSubmit(e)}>
                                <div className="form-group">
                                    <input
                                        className="form-control"
                                        type="password"
                                        placeholder="New Password"
                                        name="password"
                                        value={password}
                                        onChange={e => onChange(e)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        className="form-control"
                                        type="password"
                                        placeholder="Re-enter Password"
                                        name="repassword"
                                        value={repassword}
                                        onChange={e => onChange(e)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="submit"
                                        className="btn btn-success form-control mt-3"
                                        value="Reset Password"
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="container">
                    <div className="text-center">
                        <p className="h2 font-weight-bold">
                            Invalid or expired token!
                        </p>
                    </div>
                </div>
            );
        }
    };

    return (
        <div className="app-layout">
            <div className="page-wrapper">
                <div className="non-logged">
                    <main className="app-content">
                        <div className="content-wrapper">
                            <Alert />
                            {renderForm()}
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

ResetPassword.propTypes = {
    user: PropTypes.object.isRequired,
    checkToken: PropTypes.func.isRequired,
    resetPassword: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    user: state.user.user
});

export default connect(
    mapStateToProps,
    { checkToken, resetPassword }
)(ResetPassword);
